import React, { Component } from "react";
import { connect } from "react-redux";
import { Offline } from 'react-detect-offline';
import { compact } from 'lodash';
import { notifyUpdate, notify } from '../../shared/actions';
import { newNotification, fetchNotifications } from "../../notifications/actions";
import { fetchFcLead } from "../../CreditLimit/actions";
import { signOut } from "../../user/actions";
import classNames from 'classnames';
import Pusher from 'pusher-js';
import moment from 'moment';

import PullToRefresh from "pulltorefreshjs";
import TimedBanner from "../components/notices/TimedBanner";
import UpdateNotice from "../components/notices/UpdateNotice";
import ServiceUnavailable from "../components/notices/ServiceUnavailable";
import ZendeskComponent from '../components/misc/ZendeskComponent';
import MaintenanceNotification from '../containers/MaintenanceNotification';
import NewFeatureNotification from '../containers/NewFeatureNotification';

const isZendeskEnabled = process.env.REACT_APP_ZENDESK_ENABLED === 'true';

export class BaseLayout extends Component {
  componentWillMount() {
    this.initializePullToRefresh();
  }

  componentDidMount() {
    this.props.user.auth_token && !this.props.user.user_active && this.redirectInactiveUser();
    this.initializePusher();
    this.fetchLeadForFcConnectBanner();
  }

  initializePusher() {
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      forceTLS: true,
    });
    const notifications = pusher.subscribe(`FCA${this.props.user.id}`);
    notifications.bind(`FCA_ACTION_CENTER_NEW`, (data) => {
      this.props.newNotification();
      this.props.fetchNotifications('action_center_show');
      this.setState({ unreadNotifications: data['notify_bell'] });
    });

    const update = pusher.subscribe(`FCA_MAIN_CHANNEL`);
    update.bind(`FCA_UPDATE`, (data) => {
      this.props.notifyUpdate();
    });
  }

  initializePullToRefresh() {
    PullToRefresh.init({
      mainElement: 'body',
      onRefresh: () => window.location.reload(),
      shouldPullToRefresh: function () {
        const ptrEnabledRoutes = [
          '/',
          '/trustpasses',
          '/purchase_orders',
          '/invoices',
        ];

        return (
          ptrEnabledRoutes.includes(window.location.pathname) && !window.scrollY
        );
      },
    });
  }

  get isStillFetchingUserData() {
    return this.props.user.has_current_terms_accepted === null;
  }

  fetchLeadForFcConnectBanner = () => {
    const { user, fetchFcLead, fcLead } = this.props;
    const loggedIn = user.auth_token;
    const fetched = (fcLead || {}).id;

    loggedIn && !fetched && fetchFcLead && fetchFcLead();
  }

  redirectInactiveUser = async () => {
    await this.props.signOut();

    this.props.notify({
      header: 'The account you are trying to access has been deactivated',
      body:
        'It is likely this is a result of holding multiple accounts. Please contact your account manager to re-activate your account',
      duration: 5,
      className: '-danger',
    });
  };

  get containerClassName() {
    return classNames('ds-container', this.props.className);
  }

  get hasUpcomingMaintenance() {
    return (
      moment(
        process.env.REACT_APP_MAINTENANCE_EXPIRATION_DATE,
        'MM/DD/YYYY hh:mm A'
      ) > moment()
    );
  }

  get hasNewFeature() {
    return (
      moment(
        process.env.REACT_APP_FEATURE_EXPIRATION_DATE,
        'MM/DD/YYYY hh:mm A'
      ) > moment() && window.location.pathname !== process.env.REACT_APP_FEATURE_LINK
    );
  }

  render() {
    let children = this.props.children;
    if (children instanceof Array) {
      children = compact(children);
    }
    const childrenWithProps = React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        user: this.props.user,
      });
    });

    return (
      <div>
        <div className='modal-container' />
        <Offline>
          <ServiceUnavailable />
        </Offline>
        {this.hasUpcomingMaintenance && <MaintenanceNotification />}
        {this.hasNewFeature && <NewFeatureNotification />}
        <div className={this.containerClassName}>
          {this.props.newVersion && <UpdateNotice />}

          <TimedBanner
            header={this.props.errors.header}
            body={this.props.errors.body}
            open={this.props.errors.status > 300}
            duration={this.props.errors.duration}
            className='-danger'
          />

          {childrenWithProps}
        </div>
        { isZendeskEnabled && <ZendeskComponent /> }
      </div>
    );
  }
}

BaseLayout.defaultProps = {
  className: '_paddingBottom--epic',
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
    errors: state.shared.ui.errors,
    loading: state.shared.ui.loading.default,
    newVersion: state.shared.ui.newVersion,
    notification: state.shared.ui.rcl_notification,
    active_banner: state.shared.ui.active_banner,
    fcLead: state.fc_lead,
  };
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    newNotification: () => dispatch(newNotification()),
    fetchNotifications: (payload) => dispatch(fetchNotifications(payload)),
    notifyUpdate: () => dispatch(notifyUpdate()),
    signOut: () => dispatch(signOut()),
    notify: (payload) => dispatch(notify(payload)),
    fetchFcLead: () => dispatch(fetchFcLead())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseLayout);



// WEBPACK FOOTER //
// ./src/features/shared/containers/BaseLayout.js